import { TrackingState } from '../../../models';
import { TRACKING_MUTATIONS_KEYS } from '../tracking.const';
import { TrackingMutation } from '../tracking.interfaces';

export class SetQueryOriginMutation implements TrackingMutation {

  mutations = {
    [TRACKING_MUTATIONS_KEYS.setQueryOrigin]: (localState: TrackingState, queryOrigin: string): void => {
      localState.queryOrigin = queryOrigin;
    }
  };
}
